/**
 * scroll-to-top — shows a floating button once the page has been scrolled
 * past a threshold, and scrolls back to top on click.
 */
if (!customElements.get('scroll-to-top')) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.threshold = 400;
      this.button = this.querySelector('.scroll-to-top__btn');
    }

    connectedCallback() {
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.button.addEventListener('click', this.handleClick.bind(this));
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      this.classList.toggle('is-visible', window.scrollY > this.threshold);
    }

    handleClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  customElements.define('scroll-to-top', ScrollToTop);
}
